export const DEFAULT_MAP_VIEW = {
  coordinates: [50, 15],
  zoom: 2,
}
